module.exports = __webpack_public_path__ + "media/images/icon_list/setting-17a1701b71ed5ab5c77dbd6b741e5e71.svg";